/* eslint-disable camelcase */

import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  /**
   * Fetch list of productions (paginated)
   * @param {Number} opts.page - Page number
   * @param {Number} opts.limit - Amount of productions to fetch
   */
  getProductions(opts = {}) {
    const {
      page = 1,
      limit = 50,
      flagged = false,
      deleted = false,
    } = opts;

    return fetch(getUrl('/productions'), {
      query: {
        page,
        limit,
        flagged,
        deleted,
      },
    });
  },

  getProduction(id) {
    return fetch(getUrl(`/productions/${id}`));
  },

  createProduction(production) {
    return fetch(getUrl('/productions'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(production),
    });
  },

  /**
   * The API request for flagging (starring) a production.
   * NOTE: Flagged productions are scoped per-user.
   * @param {Number} id - The id of the production to be flagged.
   * @returns {*}
   */
  toggleStar(id) {
    return fetch(getUrl(`/productions/${id}/star`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  /**
   * Update production via REST API.
   * This excludes any changes to the `timeline`, which should be handled via deltas.
   */
  updateProduction(id, fields = {}) {
    return fetch(getUrl(`/productions/${id}`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fields),
    });
  },

  deleteProduction(id) {
    return fetch(getUrl(`/productions/${id}`), { method: 'DELETE' });
  },

  restoreProduction(id) {
    return fetch(getUrl(`/productions/${id}/restore`), { method: 'POST' });
  },
};
